export default __webpack_public_path__ + "static/media/DSCN0369.8fd75763.JPG";